import { render } from "./models-modal.vue?vue&type=template&id=a873965a"
import script from "./models-modal.vue?vue&type=script&lang=js"
export * from "./models-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__